import { Component, Input } from '@angular/core';

import { SmartModalService } from '../../../core/services/smart-modal.service';
import {RxComponent} from '../common/rx.component';

@Component({
    selector: 'itpx-content-updated-info',
    template: `
        <p *ngIf="!data.html">{{data.text | translate}}</p>
        <div *ngIf="data.html" [innerHTML]="data.text | translate | keepHtml"></div>
        <table class="table table-striped table-bordered table-hover" *ngIf="data.table">
          <tr>
            <th></th>
            <th>Name</th>
          </tr>
          <tr *ngFor="let option of options">
            <td><input type="checkbox" [(ngModel)]="option.checked" class="checkbox" /> </td>
            <td>{{option.name}}</td>
          </tr>
        </table>
        <div *ngIf="data.html && data.text2" [innerHTML]="data.text2 | translate | keepHtml"></div>
        <div class="row">
            <div class="pull-right">
                <div class="button-form col-md-12">
                    <button type="button" (click)="onYes()" class="btn btn-primary">
                        {{ data.btnYesText ? data.btnYesText :  'Yes'}}
                    </button>
                    <button type="button" (click)="onNo()" class="btn btn-default">
                        {{ data.btnNoText ? data.btnNoText :  'No'}}
                    </button>
                </div>
            </div>
        </div>
    `,
  styleUrls: ['./content-updated-info.component.css']
})
export class ContentUpdatedInfoComponent extends RxComponent {

    @Input()
    private data: any;
    private options = [];

    constructor(private modalService: SmartModalService) {
      super();
    }

    ngOnInit(){
      if(this.data.table)
        this.data.table.forEach(d => {
          this.options.push({name:d.name, value:d, checked:false});
        })
    }

    private onYes() {
        this.modalService.sendResult(this.options.filter(f => f.checked).map(f => f.value));
    }

    private onNo() {
        this.modalService.sendResult(null);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/modal/content-updated-info.component.ts